import { render, staticRenderFns } from "./CommitteesLayout.vue?vue&type=template&id=97362af4&"
import script from "./CommitteesLayout.vue?vue&type=script&lang=js&"
export * from "./CommitteesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports